import Navbar from "./Navbar";

export default function HeaderBottom({navBg, headerStyle, currency}) {
  return (
    <div
      className={`header-bottom-area ltn__border-top ltn__header-sticky ${
        navBg === "secondary"
          ? "ltn__sticky-bg-secondary ltn__secondary-bg menu-color-white"
          : "ltn__sticky-bg-white"
      } section-bg-1  d-none d-lg-block`}
    >
      <div className="container">
        <div className="row">
          <Navbar headerStyle={headerStyle} navBg={navBg} currency={currency}/>
        </div>
      </div>
    </div>
  );
};
